'use strict';/*
* 	Referring URL
*/jQuery(document).ready(function(){if($('#lead_source').length){var leadSource=document.referrer;if(leadSource.length>0){if(leadSource.indexOf('iko')!=-1){// -1 if not found, positive integer on position of occurance if found
$('#lead_source').val('IKO Contractor Locator');}else{$('#lead_source').val(leadSource);}}else{$('#lead_source').val('Other');}}});